import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6aa7cfa4")

_pushScopeId("data-v-6aa7cfa4")
const _hoisted_1 = { class: "container popup-container coupons-filter-container" }
const _hoisted_2 = { style: {"max-width":"694px","width":"100%"} }
const _hoisted_3 = { class: "orders-filter-title" }
const _hoisted_4 = { class: "filter-block" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "calendar-group" }
const _hoisted_9 = { class: "calendar-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "calendar-group" }
const _hoisted_12 = { class: "calendar-group" }
const _hoisted_13 = {
  key: 0,
  class: "form-group"
}
const _hoisted_14 = { class: "position-relative" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "position-relative" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "position-relative d-flex justify-content-start" }
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = { class: "position-relative" }
const _hoisted_23 = { class: "filter-block-footer" }
const _hoisted_24 = { class: "search-footer-btn" }
const _hoisted_25 = { class: "second-row-btns" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "middle-hidden-block" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('button.filters')), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.couponCode')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.couponCode = $event)),
            class: "bookit-input order-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.couponCode]
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.couponName')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.couponName = $event)),
            class: "bookit-input order-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.couponName]
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.activeDateFrom')), 1),
            _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.activeDateTo')), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Calendar, {
              ref: "calendar",
              class: "coupon-filter-calendar",
              modelValue: _ctx.activeDateRange.fromDate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeDateRange.fromDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Calendar, {
              class: "coupon-filter-calendar",
              ref: "calendar",
              modelValue: _ctx.activeDateRange.toDate,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeDateRange.toDate = $event)),
              minDate: _ctx.activeDateRange.fromDate,
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["modelValue", "minDate"])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.bookingDateFrom')), 1),
            _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.bookingDateTo')), 1)
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_Calendar, {
              ref: "calendar",
              class: "coupon-filter-calendar",
              modelValue: _ctx.bookingDateRange.fromDate,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.bookingDateRange.fromDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Calendar, {
              class: "coupon-filter-calendar",
              ref: "calendar",
              modelValue: _ctx.bookingDateRange.toDate,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.bookingDateRange.toDate = $event)),
              minDate: _ctx.bookingDateRange.fromDate,
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["modelValue", "minDate"])
          ])
        ]),
        (!_ctx.businessClientId)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.clubName')), 1),
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.filter.clubId,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filter.clubId = $event)),
                  valueProp: "id",
                  label: "name",
                  options: _ctx.clients,
                  id: 'type-select-' + _ctx.i,
                  "close-on-select": true
                }, null, 8, ["modelValue", "options", "id"]),
                (_ctx.filter.clubId)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.filter.clubId = ''))
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_15, [
          _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.productName')), 1),
          _createVNode("div", _hoisted_16, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.filter.productId,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.filter.productId = $event)),
              valueProp: "id",
              label: "name",
              options: _ctx.products,
              id: 'type-select-' + _ctx.i,
              "close-on-select": true
            }, null, 8, ["modelValue", "options", "id"]),
            (_ctx.filter.productId)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.filter.productId = ''))
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.priceType')), 1),
            _createVNode("div", _hoisted_18, [
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.filter.priceTypeId,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.filter.priceTypeId = $event)),
                valueProp: "id",
                label: "text",
                options: _ctx.priceTypes,
                id: 'type-select-' + _ctx.i,
                "close-on-select": true
              }, null, 8, ["modelValue", "options", "id"]),
              (_ctx.filter.priceTypeId)
                ? (_openBlock(), _createBlock("i", {
                    key: 0,
                    class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.filter.priceTypeId = ''))
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.discount')), 1),
            _createVNode("div", _hoisted_20, [
              _withDirectives(_createVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.filter.discountAmount = $event)),
                class: "bookit-input order-input col-6 col-sm-3"
              }, null, 512), [
                [_vModelText, _ctx.filter.discountAmount]
              ]),
              _createVNode(_component_Multiselect, {
                class: "col-6 col-sm-3 mx-0",
                modelValue: _ctx.filter.currencyId,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.filter.currencyId = $event)),
                valueProp: "id",
                label: "symbol",
                options: _ctx.discountTypes,
                id: 'type-select-' + _ctx.i,
                "close-on-select": true
              }, null, 8, ["modelValue", "options", "id"])
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("label", null, _toDisplayString(_ctx.$t('couponFilter.status')), 1),
            _createVNode("div", _hoisted_22, [
              _createVNode(_component_Multiselect, {
                modelValue: _ctx.filter.couponStatus,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.filter.couponStatus = $event)),
                valueProp: "id",
                label: "name",
                options: _ctx.activityStatuses(),
                id: 'type-select-' + _ctx.i,
                "close-on-select": true
              }, null, 8, ["modelValue", "options", "id"]),
              (_ctx.filter.status)
                ? (_openBlock(), _createBlock("i", {
                    key: 0,
                    class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.filter.status = ''))
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_23, [
        _createVNode("div", _hoisted_24, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.Search && _ctx.Search(...args))),
            class: "search-filter-button"
          }, _toDisplayString(_ctx.$t('button.search')), 1)
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.Close && _ctx.Close(...args)))
          }, _toDisplayString(_ctx.$t('button.close')), 1),
          _hoisted_26,
          _createVNode("button", {
            type: "button",
            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.ResetFilter && _ctx.ResetFilter(...args)))
          }, _toDisplayString(_ctx.$t('button.clearAll')), 1)
        ])
      ])
    ])
  ]))
})